import { createSlice } from "@reduxjs/toolkit";
import { Role } from "types/Role";

interface roleSlice {
  roles: Role[];
  role: Role;
  tmp: Role;
}


// Define the initial state using that type
const initialState: roleSlice = {
  roles: [],
  role: null,
  tmp: null,
};


export const roleSlice = createSlice({
  name: "roles",
  initialState: initialState,
  reducers: {
    addRoles: (state, action) => {
      state.roles = action.payload.roles;
    },
    insertRole: (state, action) => {
      state.roles = [
        ...state.roles.slice(0, action.payload),
        action.payload,
        ...state.roles.slice(action.payload)
      ]
    },
    removeRole: (state, action) => {
      const id = action.payload._id;
      state.roles = [...state.roles.filter((item) => item._id !== id)];
    },
    updateRole: (state, action) => {
      state.roles = state.roles.map((item) => item._id !== action.payload._id ? item : { ...item, ...action.payload })
    },
    updateTmpRole: (state, action) => {
      state.tmp = action.payload;
    },
    updateRolePermissions: (state, action) => {
      const roleId = action.payload.roleId;
      const permissions = action.payload.permissions;
      state.roles = state.roles.map((item) => item._id !== roleId ? item : { ...item, permissions })
    },
    resetRoleState: (state) => initialState,
  },
});

export const { addRoles, insertRole, removeRole, updateRole, updateTmpRole, updateRolePermissions, resetRoleState } = roleSlice.actions;
export default roleSlice.reducer;